import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@majourneys/shared";
import { BUTTON, KIT, kitPanel } from "./kit-tokens";

/** WhatsApp link, with the chat's share link prefilled when there is one. */
export function teamWhatsAppHref(prefill?: string | null): string {
  return prefill ? `${WHATSAPP_URL}?text=${encodeURIComponent(prefill)}` : WHATSAPP_URL;
}

/**
 * C28: "Rather ask a person?" The team picks the chat up on WhatsApp. When
 * the chat has a share link, it is prefilled so the team sees the whole
 * conversation instead of asking the guest to repeat it.
 */
export function TalkToTeam({ shareUrl }: { shareUrl?: string | null }) {
  const { t } = useTranslation();
  const href = teamWhatsAppHref(shareUrl ? t("ai_concierge.kit.team.prefill", { url: shareUrl }) : null);
  return (
    <div data-testid="kit-talk-to-team" className="flex flex-col gap-3 p-3" style={kitPanel()}>
      <div className="flex items-center gap-3">
        <span
          aria-hidden
          className="grid h-9 w-9 shrink-0 place-items-center rounded-full"
          style={{ background: KIT.navyGradient, color: KIT.gold }}
        >
          <MessageCircle size={16} />
        </span>
        <div className="min-w-0">
          <p className="text-[14px] font-semibold" style={{ color: KIT.navy }}>
            {t("ai_concierge.kit.team.title")}
          </p>
          <p className="text-[12.5px]" style={{ color: KIT.muted }}>
            {t("ai_concierge.kit.team.sub")}
          </p>
        </div>
      </div>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex min-h-[44px] w-full items-center justify-center gap-2 rounded-full text-[13.5px] font-semibold"
        style={{ ...BUTTON, color: KIT.navy }}
      >
        <span aria-hidden className="h-2 w-2 rounded-full" style={{ background: "#25D366" }} />
        {t("ai_concierge.kit.team.cta")}
      </a>
    </div>
  );
}
